<template>
  <div class="h-100">
    <TraceMap
      :tracableInfo="tracableInfo"
      style="height:300px"
      ref="mapcom"
      mapId="realtime"
      :key="'realtime'"
      v-bind="$attrs"
      @onRefresh="onRefresh"
    ></TraceMap>
    <UniversalDetail :info="tracableInfo"></UniversalDetail>
  </div>
</template>
<script>
import UniversalDetail from '@/pages/dataBoard/mapMonitor/components/ArchDetail/UniversalDetail'
import TraceMap from '../TraceMap.vue'
import { getRealtimeTrack } from '@/api/modules/map'
import bus from '@/utils/bus'

export default {
  props: ['tracableInfo', 'mapcom'],
  data () {
    return {
      timer: null
    }
  },
  components: {
    UniversalDetail,
    TraceMap
  },
  mounted () {
    this.getRealtimeTrace()
    this.timer = setInterval(this.$refs.mapcom.refresh, 1000 * 60 * 3)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    onRefresh () {
      this.getRealtimeTrace()
    },
    getRealtimeTrace () {
      if (this.tracableInfo.transit) {
        getRealtimeTrack(this.tracableInfo.carrier.id).then(({ result }) => {
          bus.$emit('onTraceRender', result, this.tracableInfo.carrier.id)
        })
      }
    }
  }
}
</script>
